<div id="manage-network-container">
  <ion-segment class="tabs" [value]="selected_tab" *ngIf="hasElevatedPermissions && network_devices && network_devices.length > 0">
    <ion-segment-button value="details" (click)="selected_tab = 'kilns'" [class.selected]="selected_tab === 'kilns'">
      {{ 'MANAGE_NETWORK.KILNS' | translate }}
    </ion-segment-button>
    <ion-segment-button (click)="selected_tab = 'network'" *ngIf="network_devices && network_devices.length > 0 && hasElevatedPermissions"
      [class.selected]="selected_tab === 'network'">
      {{ 'MANAGE_NETWORK.NETWORK_DEVICES' | translate }}
    </ion-segment-button>
  </ion-segment>
  
  <div class="main" [class.main--kiln-empty]="selected_tab === 'kilns' && kilnTabEmptyLayout">
    <div *ngIf="selected_tab === 'kilns' && kilnTabEmptyLayout" class="kiln-empty-state ion-padding">
      <div *ngIf="retrievingInformation" class="kiln-empty-state-loading"><ion-spinner name="bubbles"></ion-spinner></div>
      <ng-container *ngIf="!retrievingInformation">
        <p class="kiln-empty-state-message">{{ 'MANAGE_NETWORK.NO_KILNS_YET' | translate }}</p>
        <ion-button *ngIf="canAdminister" expand="block" class="kiln-empty-state-cta" (click)="addKiln()">
          {{ 'MANAGE_NETWORK.ADD_KILN_PRIMARY' | translate }}
        </ion-button>
      </ng-container>
    </div>

    <ng-container *ngIf="selected_tab === 'kilns' && !kilnTabEmptyLayout">
    <div [class.manage-network-kilns-sidebar--add-flow]="small_screen && new_kiln">
      <!-- <div *ngIf="small_screen" class="manage-network-kilns-intro ion-padding-horizontal">
        <h2 class="manage-network-kilns-intro-title">{{ 'MANAGE_NETWORK.KILNS_IN_MY_NETWORK' | translate }}</h2>
        <p class="manage-network-kilns-intro-hint">{{ 'MANAGE_NETWORK.KILNS_SMALL_SCREEN_HINT' | translate }}</p>
      </div> -->
      <ion-item *ngIf="!(small_screen && new_kiln)" [color]="small_screen ? undefined : 'dark'" id="list-title">
        <ion-label *ngIf="!small_screen"><h6>{{ 'MANAGE_NETWORK.KILNS_IN_MY_NETWORK' | translate }}</h6></ion-label>
        <ion-label slot="end" class="title-buttons">
          <ion-button *ngIf="small_screen" (click)="showPicker()">{{ 'MANAGE_NETWORK.SELECT' | translate }}</ion-button>
          <ion-icon class="ion-padding-end icon" *ngIf="canAdminister" name="add" [color]="small_screen ? 'dark' : 'light'" (click)="addKiln()"></ion-icon>
          <ion-icon name="remove" *ngIf="canAdminister" class="icon" [color]="small_screen ? 'dark' : 'light'" (click)="removeKiln()"></ion-icon>
        </ion-label>
      </ion-item>
      <ion-list *ngIf="kilns && kilns.length > 0 && selectedKiln && !small_screen">
        <ion-item *ngFor="let kiln of kilns" (click)="selectKiln(kiln)"
          [color]="selectedKiln ? ((selectedKiln.serial_number ? (selectedKiln.serial_number === kiln.serial_number) : (selectedKiln.kiln_id === kiln.kiln_id)) ? 'success': 'light') : 'light'">
          <ion-label>{{(kiln && kiln.name) ? kiln.name : ('MANAGE_NETWORK.NAME_UNAVAILABLE' | translate)}}</ion-label>
        </ion-item>
      </ion-list>
      <div *ngIf="retrievingInformation"><ion-spinner name="bubbles"></ion-spinner></div>
    </div>
    <div class="form">
      <!-- Add flow: scan or enter serial first -->
      <ng-container *ngIf="new_kiln && addModeStep === 'scan'">
        <ion-item lines="none">
          <ion-label><h6>{{ 'ADD_KILN.TITLE_SCAN' | translate }}</h6></ion-label>
        </ion-item>
        <div class="add-flow-scan">
          <p>{{ 'ADD_KILN.BARCODE_MESSAGE' | translate }}</p>
          <ion-button class="scan-button" (click)="scanCode()">
            {{ 'ADD_KILN.SCAN_BARCODE' | translate }}
          </ion-button>
          <a (click)="goToSerialStep()">{{ 'ADD_KILN.MANUAL_ENTER_LINK' | translate }}</a>
          <p class="add-flow-scan-help">
            {{ 'ADD_KILN.CONTROLLER_SERIAL_INTRO' | translate }}
            <strong>{{ 'ADD_KILN.WIFI_SYMBOL' | translate }}</strong>
            {{ 'ADD_KILN.CONTROLLER_SERIAL_MID' | translate }}
            <strong>{{ 'ADD_KILN.SERIAL_NUMBER_MENU' | translate }}</strong>
            {{ 'ADD_KILN.CONTROLLER_SERIAL_OUTRO' | translate }}
          </p>
          <div class="serial-number-page-example">
            <img class="main-img" src="assets/serial_number_example.png" alt="" />
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="new_kiln && addModeStep === 'serial'">
        <ion-item>
          <ion-label>{{ 'ADD_KILN.ENTER_CONTROLLER_SERIAL_PROMPT' | translate }}</ion-label>
        </ion-item>
        <ion-item class="controller-serial-field">
          <ion-label>{{ 'MANAGE_NETWORK.CONTROLLER_SERIAL_NUMBER' | translate }}</ion-label>
          <ion-input
            class="controller-serial-input"
            type="text"
            inputmode="numeric"
            maxlength="9"
            [(ngModel)]="addFlowSerial"
            [placeholder]="'ADD_KILN.CONTROLLER_SERIAL_PLACEHOLDER' | translate"
            [ngModelOptions]="{standalone: true}"
          ></ion-input>
        </ion-item>
        <ion-item lines="none">
          <ion-button *ngIf="!small_screen" class="cancel-button" (click)="cancelAddFlow()">{{ 'MANAGE_NETWORK.CANCEL' | translate }}</ion-button>
          <ion-button fill="solid" slot="end" (click)="goToDetailsStepFromAdd()">{{ 'ADD_KILN.NEXT' | translate }}</ion-button>
        </ion-item>
      </ng-container>
      <div *ngIf="addFlowError" class="add-flow-error">{{ addFlowError }}</div>

      <ion-item *ngIf="(selectedKiln || new_kiln) && !(new_kiln && (addModeStep === 'scan' || addModeStep === 'serial'))">
        <ion-label><h6>{{ 'MANAGE_NETWORK.EDIT_KILN_INFORMATION' | translate }}</h6></ion-label>
      </ion-item>
      <form [formGroup]="manageKilnForm" *ngIf="(selectedKiln || new_kiln) && !(new_kiln && (addModeStep === 'scan' || addModeStep === 'serial'))" (ngSubmit)="new_kiln ? submitNewKiln() : submitKiln(manageKilnForm.value)">
        <ion-item class="form-group-header">
          <ion-label><h6>{{ 'MANAGE_NETWORK.GENERAL' | translate }}</h6></ion-label>
        </ion-item>
        <ion-item>
          <ion-label>{{ 'MANAGE_NETWORK.DATE_INSTALLED' | translate }}</ion-label>
          <ion-input *ngIf="canAdminister" type="date" formControlName="install_date"></ion-input>
          <ion-input *ngIf="!canAdminister" disabled="true" readonly="true" [class.readonly]="true"
            type="date" formControlName="install_date"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label>{{ 'MANAGE_NETWORK.KILN_NAME' | translate }}</ion-label>
          <ion-input
            #kilnNameInput
            class="ion-text-right"
            *ngIf="canAdminister"
            type="text"
            formControlName="name"
            [placeholder]="'MANAGE_NETWORK.KILN_NAME_PLACEHOLDER' | translate"
          ></ion-input>
          <ion-input class="ion-text-right" *ngIf="!canAdminister" disabled="true" readonly="true" [class.readonly]="true"
            type="text" formControlName="name"></ion-input>
        </ion-item>

        <ion-item class="form-group-header">
          <ion-label><h6>{{ 'MANAGE_NETWORK.KILN_INFORMATION' | translate }}</h6></ion-label>
        </ion-item>
        <ion-item>
          <ion-label>{{ 'MANAGE_NETWORK.KILN_MODEL' | translate }} <ion-note>({{ 'MANAGE_NETWORK.OPTIONAL' | translate }})</ion-note></ion-label>
          <ion-select class="kiln_model" *ngIf="canAdminister" formControlName="model" [placeholder]="'MANAGE_NETWORK.SELECT_OPTIONAL' | translate">
            <ion-select-option value=""></ion-select-option>
            <ion-select-option *ngFor="let model of model_options"
              [disabled]="model.blank"
              value="{{model.modelName}}">
              {{model.modelName}}
            </ion-select-option>
          </ion-select>
        </ion-item>

        <ion-item>
          <ion-label>{{ 'MANAGE_NETWORK.VOLTAGE' | translate }} <ion-note>({{ 'MANAGE_NETWORK.OPTIONAL' | translate }})</ion-note></ion-label>
          <ion-select *ngIf="canAdminister" formControlName="voltage" [placeholder]="'MANAGE_NETWORK.SELECT_OPTIONAL' | translate">
            <ion-select-option value=""></ion-select-option>
            <ion-select-option *ngFor="let voltage of voltage_options" value="{{voltage}}">{{voltage}}</ion-select-option>
          </ion-select>
        </ion-item>

        <ion-item>
          <ion-label>{{ 'MANAGE_NETWORK.PHASE' | translate }} <ion-note>({{ 'MANAGE_NETWORK.OPTIONAL' | translate }})</ion-note></ion-label>
          <ion-select *ngIf="canAdminister" formControlName="phase" [placeholder]="'MANAGE_NETWORK.SELECT_OPTIONAL' | translate">
            <ion-select-option value=""></ion-select-option>
            <ion-select-option *ngFor="let phase of phase_options" value="{{phase}}">{{phase}}</ion-select-option>
          </ion-select>
        </ion-item>

        <ion-item>
          <ion-label>{{ 'MANAGE_NETWORK.KILN_SERIAL_NUMBER' | translate }} <ion-note>({{ 'MANAGE_NETWORK.OPTIONAL' | translate }})</ion-note></ion-label>
          <ion-input class="ion-text-right" *ngIf="canAdminister" type="text" formControlName="kiln_serial_number" [placeholder]="'MANAGE_NETWORK.KILN_SERIAL_NUMBER_PLACEHOLDER' | translate"></ion-input>
          <ion-input class="ion-text-right" *ngIf="!canAdminister" disabled="true" readonly="true" [class.readonly]="true"
            type="text" formControlName="kiln_serial_number"></ion-input>
        </ion-item>

        <ion-item class="form-group-header">
          <ion-label><h6>{{ 'MANAGE_NETWORK.CONTROLLER_INFO' | translate }}</h6></ion-label>
        </ion-item>
        <ion-item>
          <ion-label>{{ 'MANAGE_NETWORK.KMT_CONTROLLER_QUESTION' | translate }}</ion-label>
          <ion-checkbox class="right" *ngIf="canAdminister" type="checkbox" formControlName="is_kmt"></ion-checkbox>
          <ion-checkbox class="right" *ngIf="!canAdminister" disabled="true" readonly="true" [class.readonly]="true"
            type="checkbox" formControlName="is_kmt"></ion-checkbox>
        </ion-item>
        <ion-item class="controller-serial-field" *ngIf="manageKilnForm.value.is_kmt">
          <ion-label>{{ 'MANAGE_NETWORK.CONTROLLER_SERIAL_NUMBER' | translate }}</ion-label>
          <ion-input
            *ngIf="canAdminister && !(new_kiln && addFlowSerial)"
            type="text"
            inputmode="numeric"
            maxlength="9"
            class="ion-text-right controller-serial-input"
            formControlName="serial_number"
            [placeholder]="'MANAGE_NETWORK.CONTROLLER_SERIAL_NUMBER_PLACEHOLDER' | translate"
          ></ion-input>
          <ion-input
            *ngIf="canAdminister && new_kiln && addFlowSerial"
            type="text"
            class="ion-text-right controller-serial-input controller-serial-input--readonly"
            [value]="addFlowSerial"
            readonly
          ></ion-input>
          <ion-input
            *ngIf="!canAdminister"
            disabled="true"
            readonly="true"
            [class.readonly]="true"
            type="text"
            class="ion-text-right controller-serial-input controller-serial-input--readonly"
            formControlName="serial_number"
          ></ion-input>
        </ion-item>

        <ion-item *ngIf="manageKilnForm.value.is_kmt">
          <ion-label>{{ 'MANAGE_NETWORK.MAC_ADDRESS' | translate }} <ion-note>({{ 'MANAGE_NETWORK.OPTIONAL' | translate }})</ion-note></ion-label>
          <ion-input
            *ngIf="canAdminister"
            type="text"
            class="ion-text-right"
            formControlName="mac_address"
            autocapitalize="characters"
            maxlength="12"
            [placeholder]="'MANAGE_NETWORK.MAC_ADDRESS_PLACEHOLDER' | translate"
          ></ion-input>
          <ion-input
            *ngIf="!canAdminister"
            type="text"
            class="ion-text-right controller-serial-input--readonly"
            formControlName="mac_address"
            disabled="true"
            readonly="true"
            [class.readonly]="true"
          ></ion-input>
        </ion-item>

        <ion-item *ngIf="!manageKilnForm.value.is_kmt">
          <ion-label>{{ 'MANAGE_NETWORK.ATTACHED_TO_NETWORK_DEVICE' | translate }}</ion-label>
          <ion-select *ngIf="canAdminister" formControlName="network_device">
            <ion-select-option *ngFor="let nd of network_devices" value="{{nd && nd.id}}"
              [selected]="nd && nd.id === manageKilnForm.value.network_device">
              {{nd ? nd.name : ('MANAGE_NETWORK.NETWORK_DEVICE_NAME_UNAVAILABLE' | translate)}}
            </ion-select-option>
          </ion-select>
          <ion-select *ngIf="!canAdminister" formControlName="network_device">
            <ion-select-option *ngFor="let nd of network_devices"
              value="{{nd && nd.id}}" disabled="true"
              [selected]="nd && nd.id === manageKilnForm.value.network_device">
              {{nd ? nd.name : ('MANAGE_NETWORK.NETWORK_DEVICE_NAME_UNAVAILABLE' | translate)}}
            </ion-select-option>
          </ion-select>
        </ion-item>

        <ion-item *ngIf="!manageKilnForm.value.is_kmt">
          <ion-label>{{ 'MANAGE_NETWORK.KILN_ID' | translate }}</ion-label>
          <ion-input *ngIf="canAdminister" type="number" formControlName="kiln_id" [placeholder]="'MANAGE_NETWORK.KILN_ID_PLACEHOLDER' | translate"></ion-input>
          <ion-input *ngIf="!canAdminister" disabled="true" readonly="true" [class.readonly]="true"
            type="number" formControlName="kiln_id" min="1"></ion-input>
        </ion-item>
      </form>
    </div>
    </ng-container>

    <div *ngIf="selected_tab === 'network' && network_devices && network_devices.length > 0 && hasElevatedPermissions">
      <ion-item class="title">
        <ion-label><h6>{{ 'MANAGE_NETWORK.MY_NETWORK_DEVICES' | translate }}</h6></ion-label>
        <ion-button *ngIf="small_screen" (click)="showPicker()">{{ 'MANAGE_NETWORK.SELECT' | translate }}</ion-button>
      </ion-item>      
      <ion-list *ngIf="network_devices && network_devices.length > 0 && !small_screen">
        <ion-item *ngFor="let nd of network_devices" (click)="selecteNetworkDevice(nd)"
           [class.selected]="selectedNetworkDevice ? (selectedNetworkDevice.serial_number === nd.serial_number) : false">
          {{ getNdName(nd) }}
        </ion-item>
      </ion-list>
    </div>
    <div *ngIf="selected_tab === 'network'" class="form">
      <h6>{{ 'MANAGE_NETWORK.EDIT_NETWORK_DEVICE_INFORMATION' | translate }}</h6>
      <form [formGroup]="manageNetworkDeviceForm" *ngIf="selectedNetworkDevice" (ngSubmit)="submitNetworkDevice(manageNetworkDeviceForm.value)">
        <ion-item>
          <ion-label>{{ 'MANAGE_NETWORK.LOCATION_FRIENDLY_NAME' | translate }}</ion-label>
          <ion-input type="text" class="ion-text-right" disabled="true" readonly="true" formControlName="name"></ion-input>
        </ion-item>

        <ion-item>
          <ion-label>{{ 'MANAGE_NETWORK.MAC_ADDRESS' | translate }}</ion-label>
          <ion-input type="text" class="ion-text-right" disabled="true" readonly="true" formControlName="mac_address"></ion-input>
        </ion-item>

        <ion-item>
          <ion-label>{{ 'MANAGE_NETWORK.DEVICE_MODEL' | translate }}</ion-label>
          <ion-select disabled="true" formControlName="device_manufacturer">
            <ion-select-option value="1">{{ 'MANAGE_NETWORK.NETBURNER_RF1' | translate }}</ion-select-option>
            <ion-select-option value="2">{{ 'MANAGE_NETWORK.NETBURNER_SF1' | translate }}</ion-select-option>
          </ion-select>
        </ion-item>

        <ion-item>
          <ion-label>{{ 'MANAGE_NETWORK.SERIAL_NUMBER_REQUIRED' | translate }} <sup>*</sup></ion-label>
          <ion-input type="text" class="ion-text-right" disabled="true" readonly="true" formControlName="serial_number"></ion-input>
        </ion-item>

        <ion-item class="vertical"><ion-note><sup>*</sup> {{ 'MANAGE_NETWORK.SERIAL_NUMBER_NOTE' | translate }}</ion-note></ion-item>
      </form>
    </div>
  </div>

  <ion-row class="ion-justify-content-end ion-padding-end" *ngIf="showKilnTabFooter">
    <ion-button *ngIf="new_kiln && addModeStep" class="cancel-button" (click)="cancelAddFlow()">{{ 'MANAGE_NETWORK.CANCEL' | translate }}</ion-button>
    <ion-button *ngIf="!new_kiln" class="cancel-button" (click)="onDismiss ? onDismiss() : goBack()">{{ 'MANAGE_NETWORK.CANCEL' | translate }}</ion-button>
    <ion-button *ngIf="(selected_tab !== 'network') && !updating && !submittingNewKiln && new_kiln && canAdminister" (click)="submit()" type="submit" [disabled]="!canSubmitNewKiln()">{{ 'MANAGE_NETWORK.CREATE_KILN' | translate }}</ion-button>
    <ion-button *ngIf="(selected_tab !== 'network') && !updating && !new_kiln && canAdminister" (click)="submit()" type="submit">{{ 'MANAGE_NETWORK.SUBMIT' | translate }}</ion-button>
    <button *ngIf="updating || submittingNewKiln">
      <ion-spinner name="bubbles"></ion-spinner>
      <span>{{ 'MANAGE_NETWORK.UPDATING' | translate }}</span>
    </button>
  </ion-row>
</div>
